import {HttpClient} from "@angular/common/http";
import {environment} from "src/app/environments/environment";
import {inject, Injectable} from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export abstract class MoovementApiClient {

  protected baseUrl: string = environment.baseUrl
  protected httpClient = inject(HttpClient);
}
